<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('notice1.edit.ViewHeading') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('notice1.edit.ViewTitle') }}</label>
                            <InputText type="text" :class="`${error.title ? 'p-invalid' : ''}`" :placeholder="$t('notice1.edit.ViewTitle')" id="title2" v-model="title" @keydown.space="preventLeadingSpace"> </InputText>
                            <div class="text-red">{{ error.title }}</div>
                        </div>

                        <!-- <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('notice1.edit.CreatedDate') }}</label>
                            <Calendar :class="`${error.created_date ? 'p-invalid' : ''}`" :showIcon="true"
                                :showButtonBar="true" v-model="created_date" dateFormat="yy/mm/dd"
                                :placeholder="$t('notice1.edit.CreatedDate')" :manualInput="false" :max-date="new Date()" ></Calendar>
                            <div class="text-red">{{ error.created_date }}</div>
                        </div> -->
                    </div>
                </div>
                <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                    <label for="title2" id="teststs">{{ $t('notice1.edit.ViewDescription') }}</label
                    ><br />
                    <div class="textbox" :style="error?.description ? 'border: 1px solid red' : ''">
                        <!-- <Quill-Editor style="height: 200px" v-model:content="description" ref="myQuillEditor"
                            :options="editorOption" contentType="html" /> -->
                        <RichEditor v-model="set_description" :set-content="description" data-placeholder="$t('Service.Edit.Desc')" />
                    </div>
                    <div class="text-red">{{ error.description }}</div>
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('notice1.edit.Save')" class="p-button p-component p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" icon="pi pi-check" iconPos="left" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('notice1.edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button1 p-component p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import validateUpdateNotice from '../../validations/notice/validateUpdateNotice';
import NoticeService from '../../service/API/NoticeService';
import moment from 'moment';
import RichEditor from '../../components/RichEditor.vue';
export default {
    components: {
        RichEditor,
    },

    data() {
        return {
            editorOption: {
                // debug: 'info',
                modules: {
                    toolbar: [
                        'bold',
                        'italic',
                        'underline',
                        'blockquote',
                        'code-block',
                        'strike',
                        'link',
                        'image',
                        { size: ['small', false, 'large', 'huge'] },
                        { list: 'ordered' },
                        { list: 'bullet' },
                        { header: [1, 2, 3, 4, 5, 6, false] },
                        { font: [] },
                        { align: [] },
                        { script: 'sub' },
                        { script: 'super' },
                        { indent: '-1' },
                        { indent: '+1' },
                        { direction: 'rtl' },
                        { color: [] },
                        { background: [] },
                    ],
                },
                // toolbar: 'full',
                contentType: 'text',
                placeholder: '설명을 입력해주세요',
                readonly: true,
                theme: 'snow',
            },

            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // description: JSON.parse(localStorage.getItem('desc')).description,

            // mydata: {
            notice_id: '',
            title: '',
            created_date: '',
            description: '',
            set_description: '',
            // },
            error: {},
        };
    },
    created() {
        this.noticeService = new NoticeService();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        extractTextFromHTML(html) {
            const element = document.createElement('div');
            element.innerHTML = html;

            // Recursive function to traverse the DOM tree
            function traverse(node, result = '') {
                const children = node.childNodes;

                for (let i = 0; i < children.length; i++) {
                    const child = children[i];

                    if (child.nodeType === Node.TEXT_NODE) {
                        result += child.textContent;
                    } else if (child.nodeType === Node.ELEMENT_NODE) {
                        if (child.style.display !== 'none') {
                            result += traverse(child);
                        }
                    }
                }

                return result;
            }

            return traverse(element);
        },
        cancel() {
            // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },
        SubmitForm() {},
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)

            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    let vcheckData = {
                        title: this.title,
                        description: this.extractTextFromHTML(this.set_description).trim(),
                        // created_date: this.created_date,
                    };
                    const { isInvalid, error } = validateUpdateNotice(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = '';
                        this.noticeService.editNotice({ notice_id: this.$route.params.id, title: this.title, description: this.set_description, created_date: this.addDay(new Date()) }).then((res) => {
                            console.warn(res);
                            console.log(this.title);
                            localStorage.removeItem('description');
                            this.$router.push({ name: 'Notice' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'success', summary: '업데이트됨', detail: '알림이 성공적으로 업데이트되었습니다', life: 3000 });
                            }, 500);
                        });
                    }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
    },
    mounted() {
        this.noticeService.viewNotice(this.$route.params.id).then((result) => {
            this.title = result[0].title;
            this.created_date = this.dateformat(result[0].created_date);
            // this.$refs.myQuillEditor.setHTML(result[0].description);
            this.description = result[0].description;
            // localStorage.setItem('desc', result[0].description);
            // console.log(result);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

button.p-button.p-component.p-button.p-button.p-button1.p-mr-2.p-mb-2 {
    background: white;
    color: black;
}

.p-button {
    background: #000000;
    border: 1px solid #0a0a0a;
}

.p-button1 {
    background: #000000;
    border: 1px solid #0a0a0a;
}

#Save {
    background: black;
    color: white;
}
</style>
